import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { Toolbar, Typography, Box, FormControl, Select, MenuItem, useMediaQuery } from '@material-ui/core'
import { faChartArea } from '@fortawesome/pro-solid-svg-icons'

import TableViewToggle from '../TableViewToggle'

const useStyles = makeStyles((theme) => ({
  toolbar: {
    padding: theme.spacing(2),
  },
  title: {
    flex: '1 1 100%',
  },
  formControl: {
    minWidth: 200,
  },
}))

const mapGradYearLabel = (index) => {
  switch (index) {
    case 0:
      return 'Seniors'
    case 1:
      return 'Juniors'
    case 2:
      return 'Sophomores'
    case 3:
      return 'Freshmen'
    default:
      console.error('index %d was not expected', index)  
  }
}

const Header = ({
  classYears,
  error,
  loading,
  selectedClassYear,
  onChange,
  tableView,
  disableToggle,
  onViewToggle,
}) => {
  const theme = useTheme()
  const isXsScreen = useMediaQuery(theme.breakpoints.down('xs'))

  const classes = useStyles()
  const sortedLabels = useMemo(
    () =>
      loading
        ? []
        : [
            { label: 'All Class Years', value: 'all' },
            ...classYears
              .filter((year) => year !== 'all')
              .map((year, index) => ({ label: mapGradYearLabel(index), value: year })),
          ],
    [loading, classYears],
  )

  return (
    <Toolbar className={classes.toolbar}>
      <Typography className={classes.title}>Students by Month</Typography>
      <FormControl
        className={classes.formControl}
        variant="outlined"
        size="small"
      >
        {sortedLabels && sortedLabels.length > 0 && (
          <Select
            id="engagement-by-month-select"
            readOnly={loading}
            defaultValue=""
            value={selectedClassYear || 'all'}
            onChange={(e) => onChange(e.target.value)}
            disabled={loading || error}
            aria-label="class year options"
          >
            {sortedLabels.map((label) => (
              <MenuItem
                key={label.value}
                value={label.value}
              >
                {' '}
                {label.label}
              </MenuItem>
            ))}
          </Select>
        )}
      </FormControl>
      <Box m={1} />
      {!isXsScreen && (
        <TableViewToggle
          tableView={tableView}
          setTableView={onViewToggle}
          viewIcon={faChartArea}
          disabled={disableToggle}
          className={classes.tableViewToggle}
        />
      )}
    </Toolbar>
  )
}

Header.propTypes = {
  classYears: PropTypes.arrayOf(PropTypes.string).isRequired,
  error: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  selectedClassYear: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  tableView: PropTypes.bool.isRequired,
  onViewToggle: PropTypes.func.isRequired,
  disableToggle: PropTypes.bool.isRequired,
}

export default Header
